import axios from "axios";

export default {

  getCalendarSettings() {
    return axios.get("/calendar/settings");
  },
  getCenters() {
    return axios.get("/calendar/centers");
  },
  getResources() {
    return axios.get("/calendar/resources");
  },
  getAppointments(payload, { signal } = {}) {
    // signal es opcional: permite cancelar la petición con AbortController.
    // Si no se pasa, el comportamiento es idéntico al anterior.
    return axios.post("/calendar/listAppointments", payload, signal ? { signal } : undefined);
  },
  getGroupedAppointments(appointmentId) {
    return axios.get("/calendar/grouped-by-uuid/" + appointmentId);
  },
  createAppointment(payload) {
    return axios.post("/calendar/appointment", payload);
  },
  createMultipleAppointments(payload) {
    return axios.post("/calendar/create-grouped-appointment", payload);
  },
  updateMultipleAppointments(payload) {
    return axios.post("/calendar/update-grouped-appointment/", payload);
  },
  updateAppointment(appointmentId, payload) {
    return axios.post("/calendar/appointment/" + appointmentId, payload);
  },
  moveOrResizeAppointment(appointmentId, payload) {
    return axios.post("/calendar/appointment/" + appointmentId+'/moveOrResize', payload);
  },
  reassignSpaceBlock(blockId, payload) {
    return axios.post("/calendar/space-block/" + blockId + "/reassign", payload);
  },
  noShows(appointmentId, payload) {
    return axios.post("/calendar/appointment/" + appointmentId+'/noShows', payload);
  },
  attends(appointmentId) {
    return axios.get("/calendar/appointment/" + appointmentId+'/attends');
  },
  deleteAppointment(appointmentId) {
    return axios.delete("/calendar/appointment/" + appointmentId);
  },
  cancelAppointment(appointmentId) {
    return axios.post("/calendar/appointment/cancel/" + appointmentId);
  },
  pasteAppointment(appointmentId, payload) {
    return axios.post("/calendar/appointment/paste/" + appointmentId, payload);
  },
  blockDates(payload) {
    return axios.post("/calendar/blockDates", payload);
  },
  updateBlockDates(appointmentId, payload) {
    return axios.post("/calendar/blockDates/" + appointmentId, payload);
  },
  replaceVacationPeriod(payload) {
    return axios.post("/calendar/vacation-period/replace", payload);
  },
  syncClassParticipantsToFuture(payload) {
    return axios.post("/calendar/class-participants/future-sync", payload);
  },
  redeemVoucher(appointmentId, payload) {
    return axios.post("/calendar/appointment/redeem-voucher/" + appointmentId, payload);
  },
  appointmentServices(appointmentId) {
    return axios.get("/calendar/appointmentServices/" + appointmentId);
  },
  toogleWhatsAppReminders(payload){
    return axios.post("/calendar/toggleWhatsAppReminders/", payload);
  },
  getAppointment(appointmentId) {
    return axios.get("/calendar/appointment/"+appointmentId);
  },
  checkIfexistWhatsAppRemindersScheduled(){
    return axios.get("/calendar/checkIfexistWhatsAppRemindersScheduled/");
  },
  deleteWhatsAppRemindersScheduled(){
    return axios.post("/calendar/deleteWhatsAppRemindersScheduled");
  },
  sendAutomaticWhatsAppReminder(payload){
    return axios.post("/calendar/sendAutomaticWhatsAppReminder/", payload);
  },
  resendReminder(payload){
    return axios.post("/calendar/reminder/resend", payload);
  },
  whatsAppReminderJob(payload){
    return axios.post("/calendar/job/whatsapp-reminder/", payload);
  },
  sendAutomaticWhatsAppShareApp(payload){
    return axios.post("/calendar/sendAutomaticWhatsAppShareApp/", payload);
  },
  shareAppJob(payload){
    return axios.post("/calendar/job/share-app/", payload);
  },
  jobShareSurvey(payload){
    return axios.post("/calendar/job/share-survey", payload);
  },
  jobShareProofOfAttendance(payload){
    return axios.post("/calendar/job/share-proof-of-attendance", payload);
  },
  jobShareCustomerSheet(payload){
    return axios.post("/calendar/job/share-customer-sheet", payload);
  },
  jobShareConsent(payload){
    return axios.post("/calendar/job/share-consent", payload);
  },
  deleteAppointmentWithRecurrings(appointmentId) {
    return axios.delete("/calendar/appointment-recurring/" + appointmentId);
  },
  deleteGroupAppointment(appointmentId) {
    return axios.delete("/calendar/group-appointment-delete/" + appointmentId);
  },
  getManualReminderConfigs() {
    return axios.get("/calendar/manual-reminders-config");
  },
  createManualReminderConfig(payload) {
    return axios.post("/calendar/manual-reminders-config", payload);
  },
  updateManualReminderConfig(id, payload) {
    return axios.put("/calendar/manual-reminders-config/" + id, payload);
  },
  deleteManualReminderConfig(id) {
    return axios.delete("/calendar/manual-reminders-config/" + id);
  },
  exportAppointments(payload) {
    return axios.post("/calendar/export-appointments", payload, {
      responseType: 'arraybuffer'
    });
  },
};